<template>
	
	<div class="page-toolbar">
		<ul v-if="isDeleted">
			<li><a href="#" @click.prevent="$emit('restore-revision')">Restore</a></li>
		</ul>
		<ul v-else-if="isEditing">
			<li><a href="#" id="toolbar-cancel-button" @click.prevent="clickedCancelButton">Cancel</a></li>
			<li><a href="#" @click.prevent="$emit('save-edit')">Save</a></li>
		</ul>
		<ul v-else-if="selectedRevision > 0">
			<li><a href="#" @click.prevent="$emit('selected-revision', 0)">Cancel</a></li>
			<li v-if="selectedRevision != latestKnownRevision"><a href="#" @click.prevent="$emit('restore-revision')">Restore</a></li>
			<li><a href="#" @click.prevent="clickedRevisonsButton">Revisions</a></li>
		</ul>
		<ul v-else>
			<li>
				<a href="#" id="toolbar-edit-button" @click.prevent="clickedEditButton">Edit</a>
			</li>
			<li v-if="!isHomepage">
				<a href="#" id="toolbar-delete-button" @click.prevent="clickedDeleteButton">Delete</a>
			</li>
			<li class="toolbar-revisions-container">
				<a href="#" id="toolbar-revisions-button" @click.prevent="clickedRevisonsButton">History</a>
			</li>
			<li v-if="loggedIn && !isHomepage">
				<a href="#" id="toolbar-privacy-button" @click.prevent="clickedPrivacyButton">{{ isPrivate ? 'Private' : 'Public' }}</a>
			</li>
		</ul>
		<login-popover ref="loginPopover" :reason="loginPopoverReason" />
		<popover okButtonName="Delete" v-on:clicked-ok="finishedDeletePopover" ref="deletePopover">
			<div>Are you sure you want to delete this page?</div>
		</popover>
		<popover ref="privacyPopover" okButtonName="Save" v-on:clicked-ok="finishedPrivacyPopover">
			<div>Page can be seen by <select v-model="popoverPrivateValue">
				<option value="public">everyone</option>
				<option value="private">camp members only</option>
			</select></div>
		</popover>
		<page-revisions
			:guid="guid"
			:isViewingRevisions="isViewingRevisions"
			:latestKnownRevision="latestKnownRevision"
			:selectedRevision="selectedRevision"
			@close-revisions="closedRevisions"
			@selected-revision="handleSelectedRevision"
		/>
	</div>

</template>


<script>

	import Popover from './Popover.vue'
	import LoginPopover from './LoginPopover.vue'
	import PageRevisions from './PageRevisions.vue'
	import StoredState from '@/mixins/stored-state'

	export default {
		name: 'page-toolbar',
		mixins: [ StoredState ],
		props: ['guid', 'isEditing', 'isHomepage', 'isPrivate', 'isDeleted', 'selectedRevision', 'latestKnownRevision'],
		components: { Popover, LoginPopover, PageRevisions },
		data() {
			return {
				loginPopoverReason: '',
				popoverPrivateValue: '',
				isViewingRevisions: false
			}
		},
		computed: {
			loggedIn() {
				return this.$store.getters.isLoggedIn
			}
		},
		methods: {
			clickedEditButton() {
				if (this.loggedIn) {
					this.$emit('toggle-edit')
				} else {
					this.loginPopoverReason = 'You need to be logged in as a member of the Paradise Motel Discord server to edit pages.'
					this.$refs.loginPopover.showFromElement('toolbar-edit-button')
					this.callMethodAfterLogin('handleEditAfterLogin')
				}
			},
			handleEditAfterLogin() {
				if (this.loggedIn) {
					this.$emit('toggle-edit')
				}
			},
			clickedDeleteButton() {
				if (this.loggedIn) {
					this.$refs.deletePopover.showFromElement('toolbar-delete-button')
				} else {
					this.loginPopoverReason = 'You need to be logged in as a member of the Paradise Motel Discord server to delete pages.'
					this.$refs.loginPopover.showFromElement('toolbar-delete-button')
				}
			},
			async finishedDeletePopover() {
				this.$emit('delete-page')
			},
			clickedRevisonsButton() {
				this.isViewingRevisions = !this.isViewingRevisions
			},
			clickedPrivacyButton() {
				this.popoverPrivateValue = this.isPrivate ? 'private' : 'public'
				this.$refs.privacyPopover.showFromElement('toolbar-privacy-button')
			},
			finishedPrivacyPopover() {
				this.$emit(this.popoverPrivateValue === 'private' ? 'make-page-private' : 'make-page-public')
			},
			clickedCancelButton() {
				this.$emit('cancel-edit')
			},
			handleSelectedRevision(rev) {
				this.$emit('selected-revision', rev)
			},
			closedRevisions() {
				this.isViewingRevisions = false
			}
		}
	}

</script>


<style lang="scss">

	.page-toolbar {
		margin: 0;
		padding: 0;
		position: fixed;
		z-index: 1;
		width: $sidebar-width;
		height: 50vh;
		bottom: calc((100vw / #{$grass-ratio}) * 0.75);
		border-right: 2px solid #d9d9cc;
		font-size: 16px;
		line-height: 24px;

		@media (max-height: 350px) {
			display: none;
		}

		@include mobile {
			width: 100%;
			left: 0;
			bottom: 0;
			height: 30px;
			border: 0;
			z-index: 102;
		}

		& > ul {
			position: absolute;
			right: 30px;
			bottom: 0;
			list-style-type: none;
			line-height: 13px;

			@include mobile {
				position: fixed;
				left: 0;
				right: 0;
				z-index: 103;
				margin: 0;
				padding: 0;
				text-align: center;
				@supports(bottom: min(0)) {
					bottom: #{"min(7px, env(safe-area-inset-bottom))"};
				}
			}

			li {
				margin: 8px #{(-30) + 12}px;
				text-align: right;

				@include mobile {
					margin: 0;
					padding: 0 4px 0 0;
					display: inline-block;
					text-align: left;

					&:last-child {
						padding: 0;
					}

					&:last-child::after {
						content: ''
					}
					
					&::after {
						content: ' | '
					}
				}

				&.selected {
					background-color: #000;

					a {
						color: #fff;
					}
				}

				a {
					color: $body-text-color;

					@include mobile {
						color: #fff;
						line-height: 30px;
					}

					&::after {
						display: inline-block;
						position: relative;
						top: 2px;
						margin: 0 0 0 6px;
						width: 15px;
						height: 13px;
						background: url(/img/sidebar-link-arrow.png) no-repeat;
						background-position: bottom;
						line-height: 0;
						font-size: 0;
						content: ' '
					}

					@include mobile {
						&::after {
							display: none;
						}
					}

					&.active {
						background-color: red;
					}
				}
			}
		}
	}

</style>
